import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_TotalMode_Switch_Mutation = graphql(`
  mutation ResolvableMissionTypeForm_TotalMode_Switch(
    $manualTotal: ResolvableServiceValueInput
    $serviceUsagesGroupId: Id!
    $serviceUserId: Id!
    $totalMode: TotalModeEnum!
    $versionData: VersionDataInput
  ) {
    switchResolvableMissionTypeTotalMode(
      manualTotal: $manualTotal
      serviceUsagesGroupId: $serviceUsagesGroupId
      serviceUserId: $serviceUserId
      totalMode: $totalMode
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useSwitchResolvableMissionTypeTotalModeMutation = () =>
  useGraphQLMutation(ResolvableMissionTypeForm_TotalMode_Switch_Mutation);
